import { FC, ReactNode } from 'react';
import { Box, Paper } from '@mui/material';
import { COLORS } from 'services/constants/colors';
import { PgSectionHeader } from './PgSectionHeader';

type TPgPageProps = {
	/** Tab title, the last breadcrumb item. */
	title: string;
	/** Intermediate breadcrumb item, e.g. `Settings`. */
	group?: string;
	/** Buttons on the right of the header. */
	actions?: ReactNode;
	children?: ReactNode;
};

/** Body of one Payment Gateway tab: breadcrumb header and the content below it. */
export const PgPage: FC<TPgPageProps> = ({ title, group, actions, children }) => (
	<Box>
		<Paper sx={{ mb: 2, p: '4px 12px', backgroundColor: COLORS.BACKGROUND_SECONDARY }}>
			<PgSectionHeader title={title} group={group}>
				{actions}
			</PgSectionHeader>
		</Paper>
		{children}
	</Box>
);
